import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { SUPPORTED_LOCALES } from '../../i18n';

const LOCALE_LABELS: Record<string, string> = {
  en: 'English',
  ar: 'العربية',
  es: 'Español',
  fr: 'Français',
  zh: '中文',
};

export default function LanguageSwitcher() {
  const { locale, setLocale } = useLanguage();

  return (
    <select
      value={locale}
      onChange={(e) => setLocale(e.target.value)}
      className="bg-gray-100 border border-gray-300 text-gray-700 text-sm rounded-md px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-gray-400 cursor-pointer"
      aria-label="Select language"
    >
      {SUPPORTED_LOCALES.map((code) => (
        <option key={code} value={code}>
          {LOCALE_LABELS[code] || code}
        </option>
      ))}
    </select>
  );
}
